import React from 'react';
import { Flex, Box, Text, Image, AspectRatio } from '@chakra-ui/react';

export const RecommendedGameBox = ({ image, title, game }: { image?: string; title: string; game?: boolean }) => {
	return (
		<Flex flexDirection="column">
			<AspectRatio
				ratio={3 / 4}
				width="113px"
			>
				{!image ? (
					<Box
						bgColor="#2D2D2D"
						w="113px"
					>
						{' '}
						{game ? (
							<Text
								fontWeight="700"
								fontSize="12px"
							>
								{' '}
								Your image{' '}
							</Text>
						) : null}
					</Box>
				) : (
					<Image src={image} />
				)}
			</AspectRatio>
			<Text
				fontSize="11px"
				pt="6px"
			>
				{title}
			</Text>
			<Flex
				justifyContent="space-between"
				pt="8px"
				alignItems="center"
			>
				<Box
					bgColor="#468CF4"
					borderRadius="2px"
					alignItems="center"
					justifyContent="center"
					fontSize="8px"
					p="1px 4px"
				>
					BLUE
				</Box>
				<Text
					fontSize="8px"
					fontWeight="600"
				>
					$11.65
				</Text>
			</Flex>
		</Flex>
	);
};

export default RecommendedGameBox;
